import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass: "lpu-doctors-schedule d-flex flex-column",
      class: _setup.isMobile ? "ga-5" : "ga-8",
      attrs: { id: "schedule", "data-qa": "lpu_doctors_schedule" },
    },
    [
      _c(
        "h2",
        {
          staticClass: "text--text",
          class: _setup.isMobile ? "text-h6" : "text-h5",
          attrs: { "data-qa": "lpu_doctors_schedule_title" },
        },
        [_vm._v("\n    " + _vm._s(_setup.scheduleTitle) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex",
          class: _setup.isMobile
            ? "flex-column ga-4"
            : "flex-row ga-8 align-start",
        },
        [
          _c(
            "div",
            {
              staticClass: "flex-grow-1 flex-shrink-1 min-w-0",
              class: {
                "lpu-doctors-schedule__specialty--desktop": !_setup.isMobile,
              },
            },
            [
              _setup.isSpecialitiesLoading
                ? _c(VSkeletonLoader, {
                    staticClass: "lpu-doctors-schedule__skeleton-select",
                    attrs: { type: "button" },
                  })
                : _c(_setup.SpecialtySelect, {
                    attrs: {
                      specialities: _setup.specialities,
                      "selected-speciality": _setup.selectedSpeciality,
                      disabled: _setup.isFailed || _setup.isSlotsLoading,
                    },
                    on: { select: _setup.selectSpeciality },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flex-grow-1 flex-shrink-1 d-flex flex-column ga-4 min-w-0 lpu-doctors-schedule__calendar",
              class: {
                "lpu-doctors-schedule__calendar--desktop": !_setup.isMobile,
              },
              style: {
                minHeight: `${_setup.SCHEDULE_CALENDAR_MIN_HEIGHT_PX}px`,
              },
            },
            [
              _setup.context.nearest_appointment_express_datetime &&
              _setup.isExpressAppointment
                ? _c(_setup.LpuNotWorkingLabel, {
                    attrs: { "lpu-working-text": _setup.lpuNotWorkingText },
                  })
                : _vm._e(),
              _vm._v(" "),
              _setup.isLoading
                ? [_c(_setup.ScheduleCalendarSkeleton)]
                : _setup.isFailed || _setup.isEmptySchedule
                ? [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column ga-4 align-start" },
                      [
                        _c(
                          "div",
                          { staticClass: "text-body-1 text-secondary--text" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_setup.emptyStateMessage) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _setup.showCallButton
                          ? _c(
                              "div",
                              {
                                staticClass: "text-body-1 text-secondary--text",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _setup.tStatic(
                                        "Подробности уточняйте по телефону"
                                      )
                                    ) +
                                    " " +
                                    _vm._s(_setup.lpuPhoneFormatted) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _setup.showCallButton
                          ? _c(
                              VBtn,
                              {
                                staticClass: "branding-btn--primary text-none",
                                attrs: {
                                  "data-qa": "appointment-button-lpu-call",
                                  "data-google-goal":
                                    "appointment_button_lpu_call",
                                  color: "primary",
                                  depressed: "",
                                  href: `tel:${_setup.lpuPhoneHref}`,
                                  block: _setup.isMobile,
                                },
                                on: { click: _setup.onCallButtonClick },
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "ui-icon-phone-none bg-gray-0--text mr-2",
                                }),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _setup.tStatic("Позвонить в клинику")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_setup.isExpressAppointment
                          ? _c(
                              VBtn,
                              {
                                staticClass: "branding-btn--primary text-none",
                                attrs: {
                                  "data-qa": "lpu_doctors_schedule_doctors_cta",
                                  color: "primary",
                                  depressed: "",
                                  href: `${_setup.lpuDoctorsUrl}#tab-content`,
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_setup.tStatic("Запись на приём")) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                : [
                    _c(_setup.DayTabs, {
                      attrs: {
                        "data-qa": "lpu_doctors_schedule_days",
                        items: _setup.dayItems,
                        "active-date": _setup.activeDate || undefined,
                      },
                      on: { select: _setup.selectDay },
                    }),
                    _vm._v(" "),
                    _setup.activeDaySlots.length
                      ? _c(_setup.SlotButtons, {
                          attrs: {
                            "data-qa": "lpu_doctors_schedule_slots",
                            "slot-qa": "lpu_doctors_schedule_slot",
                            "expand-qa": "lpu_doctors_schedule_slots_expand",
                            slots: _setup.activeDaySlots,
                            "is-disabled": _setup.isExpressAppointment,
                          },
                          on: { click: _setup.onSlotClick },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.showCallButton
                      ? _c(
                          VBtn,
                          {
                            staticClass: "branding-btn--primary text-none",
                            attrs: {
                              "data-qa": "appointment-button-lpu-call",
                              "data-google-goal": "appointment_button_lpu_call",
                              color: "primary",
                              depressed: "",
                              href: `tel:${_setup.lpuPhoneHref}`,
                              block: _setup.isMobile,
                            },
                            on: { click: _setup.onCallButtonClick },
                          },
                          [
                            _c("span", {
                              staticClass:
                                "ui-icon-phone-none bg-gray-0--text mr-2",
                            }),
                            _vm._v(
                              "\n          " +
                                _vm._s(_setup.tStatic("Позвонить в клинику")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
              _vm._v(" "),
              _setup.isStaffUser && !_setup.isMobile
                ? _c(
                    "div",
                    {
                      staticClass:
                        "staff-appointment-type lpu-doctors-schedule__staff-appointment-type",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "staff-appointment-type__text" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _setup.selectedSpeciality
                                  ?.staff_appointment_type || ""
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }